<h1 mat-dialog-title>اطلاعات زیر را با دقت تکمیل نمایید</h1>
<div mat-dialog-content>
  <app-select-field
    [Group]="formGroup"
    [fieldName]="'stateID'"
    [fieldLabel]="'استان'"
    (OnChange)="onStateChange($event)"
    [options]="stateList"
  ></app-select-field>
  <app-select-field
    [Group]="formGroup"
    [fieldName]="'cityID'"
    [fieldLabel]="'شهر'"
    [options]="cityList"
  ></app-select-field>
  <app-date-picker-field [Group]="formGroup"
                         [fieldLabel]="'تاریخ هزینه'"
                         [fieldName]="'dateOfDamage'"
                         [maxAge]="3"
  ></app-date-picker-field>
  <app-input-field
    [Group]="formGroup"
    [fieldName]="'damageType'"
    [fieldLabel]="'شرح هزینه'"
    [dataType]="['varchar']">
  </app-input-field>
  <app-input-field
    [Group]="formGroup"
    [fieldName]="'damageAmount'"
    [fieldLabel]="'مبلغ'"
    [dataType]="['number']">
  </app-input-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="dialogRef.close();">بازگشت</button>
  <button mat-button [disabled]="!formGroup.valid" (click)="submit()" cdkFocusInitial>تایید
  </button>
</div>
